import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TestingPageModule } from './modules/testing-page/testing-page.module';
import { ShipViewTableModule } from './modules/ship-view-table/ship-view-table.module';
import { ToastrModule } from 'ngx-toastr';
import { PieChartModule } from './modules/pie-chart/pie-chart.module';
import { DialModule } from './modules/dial/dial.module';
import { BarChartModule } from './modules/bar-chart/bar-chart.module';
import { RequestFormModule } from './modules/request-form/request-form.module';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { NgxUiLoaderHttpModule, NgxUiLoaderModule } from 'ngx-ui-loader';
import { UpdateTableModule } from './modules/update-table/update-table.module';
import { HeatingPlanModule } from './modules/heating-plan/heating-plan.module';
import { RequestFormPopupModule } from './modules/request-form-popup/request-form-popup.module';
import { DailyReportModule } from './modules/daily-report/daily-report.module';
import { ConfirmPopupModule } from './modules/confirm-popup/confirm-popup.module';
import { RetriveFormModule } from './modules/retrive-form/retrive-form.module';
import { CurrentVoyagesModule } from './modules/current-voyages/current-voyages.module';
import { PastVoyagesModule } from './modules/past-voyages/past-voyages.module';
import { DatabaseTableModule } from './modules/database-table/database-table.module';
import {
  LocationStrategy,
  HashLocationStrategy,
  DatePipe,
} from '@angular/common';
import { AgmCoreModule } from '@agm/core';
import { FormPopupModule } from './modules/request-form/pages/form-popup/form-popup.module';
import { ImportDatabaseModule } from './modules/import-database/import-database.module';
import { MyShipPopupModule } from './shared/components/my-ship-popup/my-ship-popup.module';
import { ReactiveFormsModule } from '@angular/forms';
import { SubscribePopupModule } from './shared/components/subscribe-popup/subscribe-popup.module';
import { RequestformHomeModule } from './modules/requestform-home/requestform-home.module';
import { TestMapModule } from './modules/testing-page/pages/test-map/test-map.module';
import { LoginPageModule } from './modules/login-page/login-page.module';
import { CommonLogoModule } from './modules/common-logo/common-logo.module';
import { AuthInterceptor } from './shared/helpers/interceptor/interceptor';
import { MapPopupModule } from './modules/current-voyages/pages/map-popup/map-popup.module';
import { VesselStatusPopupModule } from './shared/components/vessel-status-popup/vessel-status-popup.module';
import { DatabasetabModule } from './modules/databasetab/databasetab.module';
import { FileUploadModule } from './modules/file-upload/file-upload.module';
import { SpeedConsumptionGraphModule } from './modules/speed-consumption-graph/speed-consumption-graph.module';
import { UploadfilePopupModule } from './modules/file-upload/uploadfile-popup/uploadfile-popup.module';
import { PdfViewerModule } from './shared/components/pdf-viewer/pdf-viewer.module';
import { PerformanceGraphModule } from './modules/performance-graph/performance-graph.module';
import { WeatherFactorPopupModule } from './modules/request-form/pages/form-popup/weather-factor-popup/weather-factor-popup.module';
import { PortsPopupModule } from './modules/request-form/pages/ports-popup/ports-popup.module';
import { PeriodicReportModule } from './modules/periodic-report/periodic-report.module';
import { PeriodicPopupModule } from './modules/periodic-report/periodic-popup/periodic-popup.module';
import { LandingPageModule } from './modules/landing-page/landing-page.module';
import { PerformanceTableModule } from './modules/landing-page/pages/performance-table/performance-table.module';
import { RemarksPopupModule } from './modules/ship-view-table/pages/remarks-popup/remarks-popup.module';
import { PeriodicFormModule } from './modules/periodic-report/periodic-form/periodic-form.module';

import { VesselViewModule } from './modules/PC_modules/vessel-view/vessel-view.module';

import { PortCommonTableModule } from './modules/PC_modules/port-common-table/port-common-table.module';
import { PortDashboardModule } from './modules/PC_modules/port-dashboard/port-dashboard.module';
import { PortHomeModule } from './modules/PC_modules/port-home/port-home.module';
import { PortMyRequestModule } from './modules/PC_modules/port-my-request/port-my-request.module';
import { PortRequestFormModule } from './modules/PC_modules/port-request-form/port-request-form.module';
import { PortDatabaseModule } from './modules/PC_modules/port-database/port-database.module';
import { SettingScreenModule } from './modules/PC_modules/setting-screen/setting-screen.module';
import { UploadPopupModule } from './modules/PC_modules/setting-screen/pages/upload-popup/upload-popup.module';
import { SisterShipPopupModule } from './modules/PC_modules/port-request-form/pages/sister-ship-popup/sister-ship-popup.module';
import { UploadingFilesModule } from './modules/PC_modules/setting-screen/pages/upload-popup/uploading-files/uploading-files.module';
import { OnboardingVesselsModule } from './modules/PC_modules/onboarding-vessels/onboarding-vessels.module';
import { ColumnFilterPopupModule } from './modules/databasetab/column-filter-popup/column-filter-popup.module';
import { InitialRouteReportModule } from './modules/request-form/pages/initial-route-report/initial-route-report.module';
import { DownloadPopupModule } from './modules/databasetab/download-popup/download-popup.module';
import { CHomeModule } from './modules/Cargo_Heating_modules/c-home/c-home.module';
import { AnalyticsDashboardModule } from './modules/Cargo_Heating_modules/analytics-dashboard/analytics-dashboard.module';
import { GraphsModule } from './modules/Cargo_Heating_modules/graphs/graphs.module';
import { PrintReportModule } from './modules/Cargo_Heating_modules/graphs/pages/print-report/print-report.module';
import { ReportsTableModule } from './modules/Cargo_Heating_modules/graphs/pages/reports-table/reports-table.module';
import { CustomCheckboxdropdownModule } from './shared/components/custom-checkboxdropdown/custom-checkboxdropdown.module';
import { GaugeChartModule } from './shared/components/gauge-chart/gauge-chart.module';
import { AllReportsModule } from './modules/Cargo_Heating_modules/all-requests/all-reports/all-reports.module';
import { NewRequestsFormModule } from './modules/Cargo_Heating_modules/all-requests/new-requests-form/new-requests-form.module';
import { TotalShipTableModule } from './modules/Cargo_Heating_modules/total-ship-table/total-ship-table.module';
import { PivotTableModule } from './modules/Cargo_Heating_modules/pivot-table/pivot-table.module';
import { BenchmarkingModule } from './modules/Cargo_Heating_modules/benchmarking/benchmarking.module';
import { ForecastTemperaturesDropModule } from './modules/Cargo_Heating_modules/forecast-temperatures-drop/forecast-temperatures-drop.module';
import { MasterNewformModule } from './modules/PC_modules/master-newform/master-newform.module';
import { ExpandChartModule } from './modules/PC_modules/expand-chart/expand-chart.module';
import { ReportDataModule } from './modules/PC_modules/report-data/report-data.module';
import { Q88Module } from './modules/PC_modules/q88/q88.module';
import { TcpGraphModule } from './modules/databasetab/tcp-graph/tcp-graph.module';
import { FinalFormModule } from './modules/Cargo_Heating_modules/database-form/final-form/final-form.module';
import { ReportVerifyPopupModule } from './shared/components/report-verify-popup/report-verify-popup.module';
import { GeneratePopupModule } from './modules/Cargo_Heating_modules/database-form/generate-popup/generate-popup.module';
import { CiiModule } from './modules/Emission_modules/cii/cii.module';
import { EuEtsModule } from './modules/Emission_modules/eu-ets/eu-ets.module';
import { TableViewCIIModule } from './modules/Emission_modules/cii/table-view-cii/table-view-cii.module';
import { ExcelPopupModule } from './modules/Cargo_Heating_modules/csv/excel-popup/excel-popup.module';
import { MRVModule } from './modules/Emission_modules/UK/mrv/mrv.module';
import { EmissionOverviewModule } from './modules/Emission_modules/emission-overview/emission-overview.module';
import { ImoDCSModule } from './modules/Emission_modules/imo-dcs/imo-dcs.module';
import { UkmrvShipViewModule } from './modules/Emission_modules/UK/ukmrv-ship-view/ukmrv-ship-view.module';
import { FuelEuModule } from './modules/Emission_modules/fuel-eu/fuel-eu.module';
import { GenerateEmissionReportModule } from './shared/components/generate-emission-report/generate-emission-report.module';
import { FetchBdnFileModule } from './shared/components/fetch-bdn-file/fetch-bdn-file.module';
import { InsideBdnViewModule } from './modules/Emission_modules/cii/inside-bdn-view/inside-bdn-view.module';
import { NewPlanPopupModule } from './shared/components/new-plan-popup/new-plan-popup.module';
import { SpinnerModule } from './shared/components/spinner/spinner.module';
import { ClientPopupModule } from './modules/onboarding-form/client-popup/client-popup.module';
import { ExceljsonUploadPopupModule } from './shared/components/exceljson-upload-popup/exceljson-upload-popup.module';
import { GradientWiseDropTableModule } from './modules/Cargo_Heating_modules/gradient-wise-drop-table/gradient-wise-drop-table.module';
import { RetriveReportsFetchModule } from './shared/components/retrive-reports-fetch/retrive-reports-fetch.module';
import { ConfirmVoyageNumberModule } from './shared/components/confirm-voyage-number/confirm-voyage-number.module';
import { PreviousVesselSummaryRoutingModule } from './modules/PC_modules/master-newform/previous-vessel-summary-routing/prvious-vessel-summary.routing.module';
import { CompleteVoayageModule } from './shared/components/complete-voayage/complete-voayage.module';
import { DailyLogInsertPopupModule } from './shared/components/daily-log-insert-popup/daily-log-insert-popup.module';

import { MasterreportingToolViewModule } from './shared/components/masterreporting-tool-view/masterreporting-tool-view.module';
import { ExportFilePopupModule } from './shared/components/export-file-popup/export-file-popup.module';
import { CargoHeatingDownloadPopupModule } from './shared/components/cargo-heating-download-popup/cargo-heating-download-popup.module';
import { UploadfileValidationModule } from './shared/components/uploadfile-validation/uploadfile-validation.module';
import { OptimizationPopupModule } from './modules/PC_modules/port-request-form/pages/optimization-popup/optimization-popup.module';
import { AproveErrorpopupModule } from './shared/components/aprove-errorpopup/aprove-errorpopup.module';
import { SpeedThresholdModule } from './shared/components/speed-threshold/speed-threshold.module';
import { DeviationMapPopupModule } from './shared/components/deviation-map-popup/deviation-map-popup.module';
import { TpReferencePopupModule } from './shared/components/tp-reference-popup/tp-reference-popup.module';
import { CharterPerformancePCModule } from './modules/PC_modules/charter-performance-pc/charter-performance-pc.module';
import { TechnicalPerformancePCModule } from './modules/PC_modules/tenchnical-performance-pc/tenchnical-performance-pc.module';
import { InsidecharterViewModule } from './modules/PC_modules/insidecharter-view/insidecharter-view.module';
import { InsidetechViewModule } from './modules/PC_modules/insidetech-view/insidetech-view.module';
import { GraphicalViewPCComponent } from './modules/PC_modules/graphical-view-pc/graphical-view-pc.component';
import { GraphicalViewPCModule } from './modules/PC_modules/graphical-view-pc/graphical-view-pc.module';
import { PcOptimizationviewModule } from './modules/PC_modules/pc-optimizationview/pc-optimizationview.module';
import { ConsumptionExceptionsModule } from './modules/PC_modules/consumption-exceptions/consumption-exceptions.module';
import { VersioningconfirmationvoyagePopupComponent } from './modules/PC_modules/versioningconfirmationvoyage-popup/versioningconfirmationvoyage-popup.component';
import { EmissiononboardingPopupModule } from './modules/PC_modules/emissiononboarding-popup/emissiononboarding-popup.module';
import { OnboardingProgressPopupModule } from './modules/onboarding-form/onboarding-progress-popup/onboarding-progress-popup.module';
import { DataquealityCheckformModule } from './modules/PC_modules/dataqueality-checkform/dataqueality-checkform.module';
import { GemininotesPopupModule } from './modules/PC_modules/gemininotes-popup/gemininotes-popup.module';
import { VoyagerequestFormModule } from './modules/voyagerequest-form/voyagerequest-form.module';
import { VesselOnboardEmailComponent } from './shared/components/vessel-onboard-email/vessel-onboard-email.component';
import { OnboardfieldsPopupModule } from './modules/PC_modules/onboardfields-popup/onboardfields-popup.module';
import { UpdatevesselDataModule } from './modules/updatevessel-data/updatevessel-data.module';
import { PwHomeModule } from './modules/Port_weather_modules/pw-home/pw-home.module';
import { PwMyRequestsModule } from './modules/Port_weather_modules/pw-my-requests/pw-my-requests.module';
import { PwSubmitPopupModule } from './modules/Port_weather_modules/pw-submit-popup/pw-submit-popup.module';
import { PwThanksPageModule } from './modules/Port_weather_modules/pw-thanks-page/pw-thanks-page.module';
import { AisVesselsModule } from './modules/ais-vessels/ais-vessels.module';
import { DeactivatePopupModule } from './modules/onboarding-form/deactivate-popup/deactivate-popup.module';
import { DemurrageFormModule } from './modules/demurrage_modules/demurrage-form/demurrage-form.module';
import { CreateClientModule } from './modules/Disbursment_modules/dis-repository/pages/create-client/create-client.module';
import { CreateVesselModule } from './modules/Disbursment_modules/dis-repository/pages/create-vessel/create-vessel.module';
import { CreatePortAgentModule } from './modules/Disbursment_modules/dis-repository/pages/create-port-agent/create-port-agent.module';
import { CreateCargoModule } from './modules/Disbursment_modules/dis-repository/pages/create-cargo/create-cargo.module';
import { CreatePurposeModule } from './modules/Disbursment_modules/dis-repository/pages/create-purpose/create-purpose.module';
import { CreatePortTariffModule } from './modules/Disbursment_modules/dis-repository/pages/create-port-tariff/create-port-tariff.module';
import { MultipleVesselCreationModule } from './modules/Disbursment_modules/dis-repository/pages/create-port-tariff/multiple-vessel-creation/multiple-vessel-creation.module';
import { CreateTariffModule } from './modules/Disbursment_modules/dis-repository/pages/create-tariff/create-tariff.module';
import { MasterTabsModule } from './modules/Disbursment_modules/master-tabs/master-tabs.module';
import { TariffServicesModule } from './modules/Disbursment_modules/master-tabs/pages/tariff-services/tariff-services.module';
import { CreateTariffServiceModule } from './modules/Disbursment_modules/dis-repository/pages/create-tariff-service/create-tariff-service.module';
import { CreateServiceDataModule } from './modules/Disbursment_modules/dis-repository/pages/create-tariff-service/create-service-data/create-service-data.module';
import { CargoModule } from './modules/Disbursment_modules/master-tabs/pages/cargo/cargo.module';
import { ClientModule } from './modules/Disbursment_modules/master-tabs/pages/client/client.module';
import { ViewMoreModule } from './modules/Disbursment_modules/dis-repository/pages/create-client/view-more/view-more.module';
import { ViewFieldsModule } from './modules/Disbursment_modules/dis-repository/pages/create-port/view-fields/view-fields.module';
import { PortModule } from './modules/Disbursment_modules/master-tabs/pages/port/port.module';
import { ViewEmailsModule } from './modules/Disbursment_modules/dis-repository/pages/create-port-agent/view-emails/view-emails.module';
import { PortAgentModule } from './modules/Disbursment_modules/master-tabs/pages/port-agent/port-agent.module';
import { PurposeModule } from './modules/Disbursment_modules/master-tabs/pages/purpose/purpose.module';
import { VesselModule } from './modules/Disbursment_modules/master-tabs/pages/vessel/vessel.module';
import { PdaModule } from './modules/Disbursment_modules/pda/pda.module';
import { EmailDialogModule } from './modules/Disbursment_modules/pda/email-dialog/email-dialog.module';
import { FdaModule } from './modules/Disbursment_modules/fda/fda.module';
import { DisbursmentModule } from './modules/Disbursment_modules/disbursment/disbursment.module';
import { DisbursmentFilterModule } from './modules/Disbursment_modules/disbursment/disbursment-filter/disbursment-filter.module';
import { DisplayColumnDialogModule } from './modules/Disbursment_modules/disbursment/display-column-dialog/display-column-dialog.module';
import { PaymentInstructionDialogModule } from './modules/Disbursment_modules/disbursment/payment-instruction-dialog/payment-instruction-dialog.module';
import { FileDisplayModule } from './shared/components/file-display/file-display.module';
import { FloatingFileViewerModule } from './shared/components/floating-file-viewer/floating-file-viewer.module';
import { FloatingUploadPreviewPanelModule } from './shared/components/floating-upload-preview-panel/floating-upload-preview-panel.module';
import { FdaEditModule } from './modules/Disbursment_modules/fda-edit/fda-edit.module';
import { PdaEditModule } from './modules/Disbursment_modules/pda-edit/pda-edit.module';
import { ApprovalRequestDialogModule } from './modules/Disbursment_modules/fda/approval-request-dialog/approval-request-dialog.module';
import { CommHistoryModule } from './shared/components/comm-history/comm-history.module';
import { MerakiAiModule } from './modules/Disbursment_modules/meraki-ai/meraki-ai.module';
import { FileUploadDisModule } from './modules/Disbursment_modules/pda-edit/file-upload-dis/file-upload-dis.module';
import { OthersDialogModule } from './modules/Disbursment_modules/dis-request-form/others-dialog/others-dialog.module';
import { CreateServiceModule } from './modules/Disbursment_modules/port-agent-form/create-service/create-service.module';
import { PdfaModule } from './modules/Disbursment_modules/pdfa/pdfa.module';
import { BankFormModule } from './modules/Disbursment_modules/pdfa/bank-form/bank-form.module';
import { ReturnPdaModule } from './modules/Disbursment_modules/pdfa/return-pda/return-pda.module';
import { ReviewContinueModule } from './modules/Disbursment_modules/pdfa/review-continue/review-continue.module';
import { PaFormSubmitSuccessPageModule } from './modules/Disbursment_modules/port-agent-form/pa-form-submit-success-page/pa-form-submit-success-page.module';
import { MarkdownModule } from 'ngx-markdown';
import { ConfirmDialogModule } from './modules/Disbursment_modules/dis-request-form/confirm-dialog/confirm-dialog.module';
import { TowageEditModule } from './modules/Disbursment_modules/towage-edit/towage-edit.module';
import { DocumentVerificationPopupModule } from './modules/PC_modules/port-request-form/pages/document-verification-popup/document-verification-popup.module';
import { ReportDashboardModule } from './modules/report-dashboard/report-dashboard.module';



@NgModule({
  declarations: [
    AppComponent,
    VersioningconfirmationvoyagePopupComponent,
    VesselOnboardEmailComponent,




    // ExportFilePopupComponent,
    // ReportVerifyPopupComponent,
    // CargoHeatingDownloadPopupComponent,
    // ReportDataComponent,
    // ExceljsonUploadPopupComponent,
    // GradientWiseDropTableComponent,
    // MasterreportingToolViewComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    ConfirmPopupModule,
    BrowserAnimationsModule,
    TestingPageModule,
    MatIconModule,
    MatButtonModule,
    ShipViewTableModule,
    ToastrModule.forRoot(),
    PieChartModule,
    DialModule,
    BarChartModule,
    UpdateTableModule,
    RequestFormModule,
    HeatingPlanModule,
    RequestFormPopupModule,
    DailyReportModule,
    HttpClientModule,
    RetriveFormModule,
    CurrentVoyagesModule,
    PastVoyagesModule,
    DatabaseTableModule,
    ImportDatabaseModule,
    FormPopupModule,
    AgmCoreModule,
    MyShipPopupModule,
    ReactiveFormsModule,
    SubscribePopupModule,
    RequestformHomeModule,
    CommonLogoModule,
    LoginPageModule,
    DatabasetabModule,
    MapPopupModule,
    VesselStatusPopupModule,
    FileUploadModule,
    PdfViewerModule,
    WeatherFactorPopupModule,
    SpeedConsumptionGraphModule,
    UploadfilePopupModule,
    PerformanceGraphModule,
    PortsPopupModule,
    PeriodicPopupModule,
    PeriodicReportModule,
    PerformanceTableModule,
    LandingPageModule,
    RemarksPopupModule,
    PeriodicFormModule,
    PortDashboardModule,
    PortHomeModule,
    PortCommonTableModule,
    PortRequestFormModule,
    VesselViewModule,
    PortMyRequestModule,
    SettingScreenModule,
    UploadPopupModule,
    PortDatabaseModule,
    SisterShipPopupModule,
    UploadingFilesModule,
    OnboardingVesselsModule,
    ColumnFilterPopupModule,
    InitialRouteReportModule,
    DownloadPopupModule,
    CHomeModule,
    AnalyticsDashboardModule,
    GraphsModule,
    PrintReportModule,
    ReportsTableModule,
    CustomCheckboxdropdownModule,
    GaugeChartModule,
    // CRequestFormModule,
    AllReportsModule,
    NewRequestsFormModule,
    TotalShipTableModule,
    PivotTableModule,
    BenchmarkingModule,
    ForecastTemperaturesDropModule,
    MasterNewformModule,
    ExpandChartModule,
    Q88Module,
    ReportDataModule,
    ReportVerifyPopupModule,
    ExceljsonUploadPopupModule,
    TcpGraphModule,
    FinalFormModule,
    GeneratePopupModule,
    CiiModule,
    EuEtsModule,
    TableViewCIIModule,
    ExcelPopupModule,
    MRVModule,
    EmissionOverviewModule,
    ImoDCSModule,
    UkmrvShipViewModule,
    FuelEuModule,
    GenerateEmissionReportModule,
    FetchBdnFileModule,
    InsideBdnViewModule,
    NewPlanPopupModule,
    SpinnerModule,
    ClientPopupModule,
    GradientWiseDropTableModule,
    RetriveReportsFetchModule,
    ConfirmVoyageNumberModule,
    PreviousVesselSummaryRoutingModule,
    CompleteVoayageModule,
    DailyLogInsertPopupModule,
    MasterreportingToolViewModule,
    PcOptimizationviewModule,
    ConsumptionExceptionsModule,
    CargoHeatingDownloadPopupModule,
    UploadfileValidationModule,
    AproveErrorpopupModule,
    SpeedThresholdModule,
    DeviationMapPopupModule,
    GraphicalViewPCModule,

    InsidecharterViewModule,
    TechnicalPerformancePCModule,
    CharterPerformancePCModule,
    EmissiononboardingPopupModule,
    OnboardingProgressPopupModule,
    DataquealityCheckformModule,
    GemininotesPopupModule,
    VoyagerequestFormModule,
    OnboardfieldsPopupModule,
    UpdatevesselDataModule,
    // FinalReportModule,
    NgxUiLoaderModule.forRoot({
      hasProgressBar: false,
      overlayColor: 'transparent',
      blur: 0,
    }),
    NgxUiLoaderHttpModule.forRoot({
      showForeground: true,
      exclude: [
        '/scperformance/looker-studio-stats',
        '/scperformance/looker-studio-chart-data',
        '/scperformance/looker-studio-segments',
        '/scperformance/fleet-view',
        '/fleet/map',
        '/scperformance/get-total-record',
        '/scperformance/update_notification_status',
        '/scperformance/looker-studio-data',
        '/scperformance/looker-studio-vessels',
        '/scperformance/vessel-insights',
        '/get-port-consumption-report',
        '/api/cargo-heating',
        '/cargo-heating',
        '/cargo_heating',
        '/get-cargo-heating',
        // Emission dashboard – these fire on every emission page load and must not block the global spinner
        '/v1/emission/dashboard-stats',
        '/v1/emission/cii-benchmarking',
        '/v1/emission/intensity-benchmarking',
        '/v1/emission/area-distribution',
        '/v1/emission/fleet-mini-view',
        '/v1/emission/fleet-summary',
        '/emission/vessels-historical',
        '/emission/vessels',
        '/v1/emission/cii-predictive-allowance',
        '/emission/dashboard-stats'
      ]
    }),
    TestMapModule,
    OptimizationPopupModule,
    TpReferencePopupModule,
    PwHomeModule,
    PwMyRequestsModule,
    PwSubmitPopupModule,
    PwThanksPageModule,
    AisVesselsModule,
    DeactivatePopupModule,
    DemurrageFormModule,
    CreateClientModule,
    CreateVesselModule,
    CreatePortAgentModule,
    CreateCargoModule,
    CreatePurposeModule,
    CreatePortTariffModule,
    MultipleVesselCreationModule,
    CreateTariffModule,
    MasterTabsModule,
    TariffServicesModule,
    CreateTariffServiceModule,
    CreateServiceDataModule,
    CargoModule,
    ClientModule,
    ViewMoreModule,
    ViewFieldsModule,
    PortModule,
    ViewEmailsModule,
    PortAgentModule,
    PurposeModule,
    VesselModule,
    PdaModule,
    EmailDialogModule,
    FdaModule,
    DisbursmentModule,
    DisbursmentFilterModule,
    DisplayColumnDialogModule,
    PaymentInstructionDialogModule,
    FileDisplayModule,
    FloatingFileViewerModule,
    FloatingUploadPreviewPanelModule,
    FdaEditModule,
    PdaEditModule,
    ApprovalRequestDialogModule,
    CommHistoryModule,
    MerakiAiModule,
    FileUploadDisModule,
    OthersDialogModule,
    CreateServiceModule,
    PdfaModule,
    PaFormSubmitSuccessPageModule,
    MarkdownModule.forRoot(),
    ConfirmDialogModule,
    TowageEditModule,
    DocumentVerificationPopupModule,
    ReportDashboardModule
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    DatePipe,
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
